export const CHECK_POLICY = 'CHECK_POLICY';
export const DELETE_POLICY = 'DELETE_POLICY';
export const GET_POLICY_LIST = 'GET_POLICY_LIST';
export const INSERT_POLICY = 'INSERT_POLICY';
export const RECEIVE_POLICY_LIST = 'RECEIVE_POLICY_LIST';
